import {
  Paper,
  Stack,
  Group,
  Text,
  Badge,
  Progress,
  ThemeIcon,
  Divider,
  Box,
  Grid,
} from "@mantine/core";
import { Sparkline } from "@mantine/charts";
import { AppIcon } from "../common/AppIcon";
import { activeCampaigns } from "../../data/mockData";

const CHANNEL_COLORS = { linkedin: "blue", mail: "orange", reply: "teal" };

const STATUS_STYLE = {
  Active: { color: "teal" },
  "En pause": { color: "yellow" },
};

const TREND_COLOR = { up: "teal", down: "red", flat: "gray" };

function ChannelIcons({ channels }) {
  return (
    <Group gap={0} wrap="nowrap">
      {channels.map((ch) => (
        <ThemeIcon
          key={ch}
          variant="light"
          color={CHANNEL_COLORS[ch]}
          size={22}
          radius="xl"
        >
          <AppIcon name={ch} size={12} />
        </ThemeIcon>
      ))}
    </Group>
  );
}

function CampaignRow({ campaign }) {
  const percent = campaign.total ? (campaign.sent / campaign.total) * 100 : 0;
  const status = STATUS_STYLE[campaign.status] ?? { color: "gray" };

  return (
    <Grid align="center" gutter="md">
      <Grid.Col span={{ base: 12, sm: 7 }}>
        <Group gap="sm" mb={10} wrap="nowrap">
          <Text fw={400} lineClamp={1}>
            {campaign.name}
          </Text>
          <Badge
            variant="light"
            color={status.color}
            radius="sm"
            size="sm"
            tt="none"
            style={{ flexShrink: 0 }}
            c={"var(--mantine-color-primary-9)"}
            fw={400}
          >
            {campaign.status}
          </Badge>
        </Group>
        <Group gap="sm" wrap="nowrap">
          <ChannelIcons channels={campaign.channels} />
          <Progress
            value={percent}
            color="primary"
            size="sm"
            radius="xl"
            style={{ minWidth: 200 }}
          />
          <Text fz="sm" c="gray.6" style={{ flexShrink: 0 }} w={64} ta="right">
            {campaign.sent} / {campaign.total}
          </Text>
        </Group>
      </Grid.Col>

      <Grid.Col span={{ base: 12, sm: 5 }}>
        <Group justify="flex-end" gap="xl" wrap="nowrap">
          <Sparkline
            w={120}
            h={40}
            data={campaign.spark}
            curveType="natural"
            color={TREND_COLOR[campaign.trend]}
            fillOpacity={0}
            strokeWidth={2}
          />
          <Box ta="right" style={{ flexShrink: 0, minWidth: 92 }}>
            <Text fw={700} fz="lg" lh={1} c="var(--mantine-color-primary-9)">
              {campaign.rate}
            </Text>
            <Text fz="sm" c="var(--mantine-color-primary-9)" lh={1} mt={8}>
              de taux de réponse
            </Text>
          </Box>
        </Group>
      </Grid.Col>
    </Grid>
  );
}

export function ActiveCampaigns() {
  return (
    <Paper
      radius="lg"
      p={{ base: "md", sm: "xl" }}
      withBorder
      bg={"#fcfbff"}
      style={{
        borderColor: "#edebeb",
        boxShadow: "0 1px 8px rgba(0,0,0,0.05)",
      }}
    >
      <Text fw={700} fz="lg">
        Campagnes actives
      </Text>
      <Text fz="sm" c="gray.6" mb="lg">
        Suivez les performances de vos campagnes en temps réel
      </Text>

      <Stack gap="md">
        {activeCampaigns.map((campaign, i) => (
          <Box key={campaign.id}>
            {i > 0 && <Divider mb="md" />}
            <CampaignRow campaign={campaign} />
          </Box>
        ))}
      </Stack>
    </Paper>
  );
}

export default ActiveCampaigns;
